// src/components/About.js

import useReveal from "../hooks/useReveal";

export default function About() {
  // hook returns a ref + "visible" class when element is in view
  const [ref, visible] = useReveal({ threshold: 0.18, rootMargin: "-40px" });

  return (
    <section id="ourstory" aria-labelledby="about-heading" className="py-20">
      <div className="container mx-auto px-4 max-w-6xl">
        <div
          ref={ref}
          className={`grid gap-8 items-center md:grid-cols-2 ${
            visible ? "animate-fade-up" : "opacity-0 translate-y-6"
          }`}
        >
          {/* LEFT: headline + paragraphs */}
          <div className="order-1 md:order-1">
            <p className="text-sm font-medium text-brand-deep mb-3">Our story</p>

            <h2
              id="about-heading"
              className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight text-[var(--primary)]"
            >
              LoanPulse — built for the people who make loans possible
            </h2>

            <div className="mt-6 space-y-4 text-slate-700 max-w-prose">
              <p>
                Behind every loan is a dream — a home, a business, a new beginning. Yet the process is
                often filled with confusion, scattered messages, and slow communication.
              </p>

              <p>
                We built LoanPulse because we believe loan journeys should be simple, structured, and
                stress-free.
              </p>
              <p className="muted mt-8 max-w-prose">
              With tools designed for real DSAs, agents, and financial teams, we’re turning slow,
              messy workflows into fast, organized processes.
            </p>
            <h2 className="text-base font-semibold text-brand-deep">Our mission</h2>
              <p className="mt-2 text-slate-600">Bring clarity and confidence to every loan journey.</p>
            </div>
          </div>

          {/* RIGHT: quote card + optional illustration */}
          <aside className="order-2 md:order-2 flex justify-center md:justify-end">
            <div className="w-full max-w-md space-y-6">
             
              <div className="card p-4 flex items-center gap-4">
                  <img src="/screens/about.png" alt="LoanPulse preview" className="h-auto rounded-lg" />

                </div>
            
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
